import AbstractService from '@/services/abstractService'

class PhaseFiveService extends AbstractService {
  endpoint = 'projects'

  post(id, data) {
    console.log('dataaa', data)
    // define append form
    const formData = new FormData()
    for (const key in data) {
      if(key === 'completionForm'){
        if(data[key] != null){
          formData.append(key, data[key])
        } else{
          formData.append(key, '')
        }
      }else{
        for (const index in data[key]) {
          if(data[key] != null){
            formData.append(`${key}[${index}]`, data[key][index])
          } else{
            formData.append(`${key}[${index}]`, '')
          }
        }
      }
    }
    return this.http.post(`${this.endpoint}/${id}/phase5`, formData)

    // return this.http.post(`${this.endpoint}/${data.id}`, formData)
  }
  delete(data) {
    return this.http.delete(`${this.endpoint}/media/${data}`)
  }
}

const Service = new PhaseFiveService()

export default Service
